import React from 'react';

import { useTheme } from 'styled-components';

import { SITE_KOREANAIR_SAVINGS, SITE_SKYPASS } from '@ecp/common/src/const/site/siteNumberConst';

import { useSiteComponentResolver } from '@mo-hooks/resolver/SiteComponentResolverHook';

import { ReactComponent as IconDefault } from '@mo-assets/icon/icon__go_back-nofill.svg';
import { ReactComponent as IconSkypass } from '@mo-assets/icon/skypass/icon__go_back.svg';

const GoBackIcon = ({ ...rest }) => {
  const theme = useTheme();

  const ResolvedIcon = useSiteComponentResolver(<IconDefault { ...rest } fill={theme.color.icon.mo ?? '#141415'} />, {
    [SITE_SKYPASS]: <IconSkypass { ...rest } />,
    [SITE_KOREANAIR_SAVINGS]: <IconSkypass { ...rest } />,
  });

  return (
    <>
      {ResolvedIcon}
    </>
  );
};

export default GoBackIcon;
